export const DEFAULT_DOCUMENT_TITLE = 'Review Lumen';

export function formatDocumentTitle(pageTitle: string): string {
  return `${pageTitle} | ${DEFAULT_DOCUMENT_TITLE}`;
}
